<template>
    <div class="o-productsModal">
        <div class="l-container o-productsModal__container">
            <div
                class="l-row l-row--multiline is-mobile o-productsModal__titleWrapper"
            >
                <div v-if="upsell" class="l-row__column">
                    <h2 class="a-text a-text--big a-text--bold">Dodaj produkty</h2>
                </div>
                <div class="l-row__column o-productsModal__searchWrapper">
                    <a-control
                        class="o-productsModal__request"
                        v-model="searchQuery"
                        id="search"
                        placeholder="Szukaj"
                    />
                </div>
                <div
                    class="l-row__column l-row__column--12 o-productsModal__filters"
                >
                    <a-button
                        @click="currentCategory = null"
                        :class="{
                            'a-button--active': currentCategory === null
                        }"
                        :gray="true"
                        >Wszystko</a-button
                    >
                    <a-button
                        v-for="category in packageCategories"
                        v-bind:key="`packageCategories${category.id}`"
                        :gray="true"
                        @click="currentCategory = category.id"
                        :class="{
                            'a-button--active': currentCategory === category.id
                        }"
                    >
                        {{ category.name }}
                    </a-button>
                </div>
            </div>
            <div
                class="l-row l-row--multiline is-mobile o-productsModal__productList"
            >
                <div
                    v-for="product in filteredProducts"
                    class="l-row__column l-row__column--3"
                    :class="{
                        'o-productsModal__hidden': searchConditions(product)
                    }"
                    :key="product.id"
                >
                    <product-box
                        :product="product"
                        :day-in-week="dayInWeek"
                        :address-id="addressId"
                        :show-in-modal="true"
                        :show-buttons="false"
                        :is-one-time-order="isOneTimeOrder"
                        :upsell="true"
                    />
                </div>
                <p
                    v-if="products && filteredProducts.length === 0"
                    class="o-productsModal__text"
                >
                    Brak produktów spełniających podane kryteria
                </p>
            </div>
            <div class="a-mobile__buttons o-productsModal__footer">
                <button
                    v-if="!upsell"
                    @click="closeModal"
                    class="a-button a-button--primary o-productsModal__footerButton"
                >
                    Dalej <a-icon class="a-button__icon" icon="Right" />
                </button>
            </div>
        </div>
        <o-modal
            name="thresholdAmount"
            :disable-close="true"
        >
            <template slot="content" slot-scope="props">
                <p class="a-text a-text--big a-text--center">
                    {{ props.payload.message }}
                </p>
                <br />
                <a-button
                    class="a-button--primary"
                    @click="resetOrder"
                >Powrót do początku</a-button>
            </template>
        </o-modal>
    </div>
</template>

<script>
import ProductBox from '@/components/ProductBox'
import AIcon from './global/AIcon.vue'
export default {
    components: {
        ProductBox,
        AIcon
    },
    props: {
        dayInWeek: {
            type: Number,
            required: true
        },
        addressId: {
            type: Number,
            required: true
        },
        upsell: {
            type: Boolean,
            required: false
        },
        isOneTimeOrder: {
            type: Boolean,
            required: false
        },
        showButtons: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            searchQuery: '',
            currentCategory: null
        }
    },
    watch: {
        modalStatus() {
            this.currentCategory = null
        }
    },
    computed: {
        modalStatus() {
            return this.$store.getters.modalStatus('products')
        },
        products() {
            const packages = this.$store.getters.packagesPackagesWithPrice(this.addressId, this.isOneTimeOrder)
            return packages
                ? packages.filter(
                    product =>
                        (this.currentCategory === null ||
                              product.categories.includes(
                                  this.currentCategory
                              )) &&
                          this.normalize(product.name).includes(
                              this.normalize(this.searchQuery)
                          )
                )
                : null
        },
        filteredProducts() {
            if (this.upsell && this.products !== null) {
                const result = this.products.filter(product => !this.beforeUpsell.packages.find(({ id }) => product.id === id))
                return result
            } else {
                return this.products
            }
        },
        packageCategories() {
            return this.$store.getters.packageCategories(this.addressId)
        },
        beforeUpsell() {
            return this.$store.getters['deliveries/beforeUpsell']
        },
        weekDayOrderSum() {
            return this.$store.getters.weekDayOrderSum(
                this.dayInWeek,
                this.addressId
            )
        },
        weekOrders() {
            return this.$store.getters.weekOrders
        },
        weekAmount() {
            return this.$store.getters['weekCart/weekAmount']
        },
        weekPrice() {
            return this.$store.getters.weekAmount(this.addressId, this.isOneTimeOrder)
        },
        upsellProductsErrorMessage() {
            return this.$store.getters['deliveries/upsellProductsErrorMessage']
        }
    },
    methods: {
        normalize(string) {
            return string
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\u0142/g, 'l')
        },
        searchConditions(product) {
            return (
                this.normalize(this.searchQuery) !== '' &&
                !this.normalize(product.name).includes(
                    this.normalize(this.searchQuery)
                )
            )
        },
        closeModal() {
            this.$store.dispatch('modalHide', this.name)
        }

    }
}
</script>
